import { Injectable } from "@angular/core";
import Swal from 'sweetalert2';
import { environment } from "../../../environments/environment";
import { ConstantsService } from "@app/common/constants.service";

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    private readonly swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: this.constantService.confirmButtonCSS,
            cancelButton: this.constantService.cancelButtonCSS
        },
        buttonsStyling: false,
        allowOutsideClick: false,
        reverseButtons: true
    });

    public readonly SuccessIcon = 'success';
    public readonly ErrorIcon = 'error';
    public readonly WarningIcon = 'warning';
    public readonly InfoIcon = 'info';
    public readonly QuestionIcon = 'question';

    constructor(private readonly constantService: ConstantsService) { }

    public buildDialog(): typeof Swal {
        return this.swalWithBootstrapButtons;
    }

    /**
  * Build a dialog with custom icon
  * @param icon icon type to show, use the constants (e.g. success, error, warning, info, question) of this class
  * @returns type of Swal
  */
    public buildDialogCustomIcon(icon: string): typeof Swal {
        let iconUrl = null;
        // Switch for icon, New icons can be added here
        if (icon.toLowerCase() == this.WarningIcon.toLowerCase()) {
            // set icon url
            iconUrl = `${environment.APP_CDN}/assets/images/alert-icons/warning.svg`;
        }

        // If icon url is set, return swal with custom icon
        if (iconUrl) {
            return this.swalWithBootstrapButtons.mixin({
                imageUrl: iconUrl,
                imageWidth: 75,
                imageHeight: 75,
                imageAlt: icon,
                icon: null
            });
        }

        return this.swalWithBootstrapButtons;
    }
}
